/** Takshify / Parashari env var names (Vite client). */
export const ENV = {
  supabaseUrl: 'VITE_SUPABASE_URL',
  supabasePublishable: 'VITE_SUPABASE_PUBLISHABLE_KEY',
  serverUrl: 'VITE_SERVER_URL',
};

/** @param {string | undefined} value */
function trimEnv(value) {
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * Vite inlines only static import.meta.env.VITE_* references at build time.
 * @returns {string}
 */
export function readSupabaseUrlFromBuildEnv() {
  return trimEnv(import.meta.env.VITE_SUPABASE_URL);
}

/** @returns {string} */
export function readSupabasePublishableFromBuildEnv() {
  return (
    trimEnv(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) ||
    trimEnv(import.meta.env.VITE_SUPABASE_ANON_KEY)
  );
}

/** @returns {string} */
export function readServerUrlFromBuildEnv() {
  return (
    trimEnv(import.meta.env.VITE_SERVER_URL) ||
    trimEnv(import.meta.env.VITE_SITE_URL)
  );
}
